// Tooltip texts for Guaraní classification. Values can be overridden by Vite env vars
// e.g. VITE_TOOLTIP_GUARANI_ESTRUCTURA_GUARANI_TITLE, VITE_TOOLTIP_JOPARA_DESC, etc.
const tips = {
  guarani_estructura_guarani: {
    title: import.meta.env.VITE_TOOLTIP_GUARANI_ESTRUCTURA_GUARANI_TITLE || "Guaraní con Estructura Guaraní",
    desc: import.meta.env.VITE_TOOLTIP_GUARANI_ESTRUCTURA_GUARANI_DESC || "Es la comunicación o texto redactado íntegramente en lengua guaraní, respetando su propia morfología, sintaxis, fonología y particularidades aglutinantes.",
    example: import.meta.env.VITE_TOOLTIP_GUARANI_ESTRUCTURA_GUARANI_EXAMPLE || ""
  },
  guarani_estructura_castellano: {
    title: import.meta.env.VITE_TOOLTIP_GUARANI_ESTRUCTURA_CASTELLANO_TITLE || "Guaraní con Estructura Castellano",
    desc: import.meta.env.VITE_TOOLTIP_GUARANI_ESTRUCTURA_CASTELLANO_DESC || "Se refiere al uso del idioma guaraní pero adaptado a la sintaxis y el orden lógico del español.",
    example: import.meta.env.VITE_TOOLTIP_GUARANI_ESTRUCTURA_CASTELLANO_EXAMPLE || ""
  },
  jopara: {
    title: import.meta.env.VITE_TOOLTIP_JOPARA_TITLE || "Jopara",
    desc: import.meta.env.VITE_TOOLTIP_JOPARA_DESC || "Variante más cotidiana del guaraní en Paraguay; puede incluir rasgos de hibridación con el español.",
    example: import.meta.env.VITE_TOOLTIP_JOPARA_EXAMPLE || ""
  },
  jehea: {
    title: import.meta.env.VITE_TOOLTIP_JEHEA_TITLE || "Jehe'a (Guaraní paraguayo)",
    desc: import.meta.env.VITE_TOOLTIP_JEHEA_DESC || "Mezcla o préstamo léxico entre guaraní y español; combina palabras y estructuras de ambas lenguas.",
    example: import.meta.env.VITE_TOOLTIP_JEHEA_EXAMPLE || 'Ejemplo: "venina na" (venina = español, na = guaraní)'
  }
};

export default tips;
